const voiceSwiper = new Swiper(".js-voiceSwiper", {
	loop: true,
	speed: 700,
	centeredSlides: true,
	slidesPerView: 3,
	spaceBetween: 30,

	autoplay: {
		delay: 4000,
		disableOnInteraction: false
	},

	navigation: {
		prevEl: ".p-frontVoice__prev",
		nextEl: ".p-frontVoice__next"
	},

	pagination: {
		el: ".p-frontVoice__pagination",
		clickable: true
	},

	breakpoints: {
		0: {
			slidesPerView: 1.5,
			spaceBetween: 15
		},

		768: {
			slidesPerView: 2,
			spaceBetween: 20
		},

		1024: {
			slidesPerView: 3
		}
	}
});